import React from 'react';
import DatePicker from 'react-mobile-datepicker';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { setBoardingDate } from '../../redux/cart/cart.action';
import { selectBoardingDate } from '../../redux/cart/cart.selector'

import './datepicker.style.css'



class datePicker extends React.Component {

    state = {
        isOpen: false
    }
    formatdate = (date) => {
        let dd = date.getDate();
        let mm = date.getMonth() + 1;
        let yyyy = date.getFullYear();

        if (dd < 10) {
            dd = "0" + dd;
        }
        if (mm < 10) {
            mm = "0" + mm;
        }
        return dd + "-" + mm + "-" + yyyy;
    }
    handleClick = () => {
        this.setState({ isOpen: true });
    }
    handleCancel = () => {
        this.setState({ isOpen: false });
    }

    handleSelect = (time) => {
        this.setState({ isOpen: false });
        const formattedDate = this.formatdate(time);
        this.props.setDate(formattedDate);

    }
    
    componentDidMount() {
        const { boardingDate, setDate } = this.props;
        if (boardingDate === '') {
            const today = this.formatdate(new Date());
            setDate(today);
        }
    }

    render() {
        const { boardingDate } = this.props
        const monthMap = {
            '1': 'Jan',
            '2': 'Feb',
            '3': 'Mar',
            '4': 'Apr',
            '5': 'May',
            '6': 'Jun',
            '7': 'Jul',
            '8': 'Aug',
            '9': 'Sep',
            '10': 'Oct',
            '11': 'Nov',
            '12': 'Dec',
        };        
        const dateConfig = {

            'date': {
                format: 'DD',
                caption: 'Date',
                step: 1,
            },                        
            'month': {
                format: value => monthMap[value.getMonth() + 1],
                caption: 'Month',
                step: 1,
            },
            'year': {
                format: 'YYYY',
                caption: 'Year',
                step: 1,
            },            
        };
        return (
            <div className="dateArea" >
                <label>
                    Boarding date*
                </label>

                <input
                    readOnly
                    type="text"
                    id="boarding_date"
                    value={boardingDate}
                    onClick={this.handleClick}
                />
                <br /><div id="boarding_date_error" style={{ color: "red", fontSize: "9px", display: "none" }}>Enter boarding date</div>

                <DatePicker
                    confirmText={"Confirm"}
                    cancelText={"Cancel"}                    
                    headerFormat={'DD-MM-YYYY'}
                    defaultValue={new Date(boardingDate)}
                    isOpen={this.state.isOpen}
                    onSelect={this.handleSelect}
                    showCaption={true}
                    onCancel={this.handleCancel}
                    dateConfig = {dateConfig} />
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    boardingDate: selectBoardingDate
})

const mapDispatchToProps = dispatch => ({
    setDate: date => dispatch(setBoardingDate(date))
})

export default connect(mapStateToProps, mapDispatchToProps)(datePicker);